import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/empleado/getEmpleadosByComisiones.php';

export default function getEmpleadosByComisiones({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}